import { Icon, Text, TextButton } from '@oneaudi/unified-web-components';
import { useI18n } from '~/app/i18n/i18n';
import { useMarketConfig } from '~/app/market-config';
import {
	ButtonSectionStyles,
	PriceSectionStyles,
} from '~/app/pages/configurator/components/conflict-dialog/components/styles/summary-and-confirmation-style';

export function PriceSummaryAndConfirmation({
	totalPrice,
	priceChange,
	onAccept,
	onDecline,
	isLoading,
	isLoadingAccept,
	isError,
}: {
	totalPrice: string | null | undefined;
	priceChange: string;
	onAccept: () => void;
	onDecline: () => void;
	isLoading: boolean;
	isLoadingAccept: boolean; // Extra loading flag to prevent "Calculating price..." from showing up after solution has been accepted
	isError: boolean;
}) {
	const { i18n } = useI18n();
	const { config } = useMarketConfig();

	return (
		<div className="flex flex-col gap-8">
			{isError ? (
				<>
					<div className="flex gap-4 py-4">
						<Icon name="caution" size="s" />
						<Text>{i18n('ngc.errors.conflict')}</Text>
					</div>

					<div>
						<TextButton variant="primary" onClick={onDecline} size={'md'}>
							{i18n('ngc.actions.cancel')}
						</TextButton>
					</div>
				</>
			) : (
				<>
					{config.showPrices && (
						<PriceSectionStyles>
							<div className="price-content">
								<Text variant={{ type: 'copy', order: '1', style: 'bold' }}>
									{i18n('ngc.conflict.priceChange')}
								</Text>
								<Text variant={{ type: 'copy', order: '1', style: 'bold' }}>{priceChange}</Text>
							</div>

							<div className="fprice-content">
								<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
									{i18n('ngc.conflict.total')}
								</Text>
								<Text variant={{ type: 'copy', order: '1', style: 'normal' }}>
									{!isLoading ? (
										<>{totalPrice ?? i18n('ngc.common.priceNotAvailable')}</>
									) : (
										<>{i18n('ngc.currency.calculatingPrice')}...</>
									)}
								</Text>
							</div>
						</PriceSectionStyles>
					)}

					<ButtonSectionStyles>
						<TextButton variant="secondary" onClick={onDecline} size="md">
							{i18n('ngc.conflict.decline')}
						</TextButton>
						<TextButton
							variant="primary"
							onClick={onAccept}
							disabled={isLoading || isLoadingAccept || isError}
							isLoading={isLoading || isLoadingAccept}
							size={'md'}>
							{i18n('ngc.conflict.accept')}
						</TextButton>
					</ButtonSectionStyles>
				</>
			)}
		</div>
	);
}
